// extracted by mini-css-extract-plugin
module.exports = {"root":"Transactions_root__3tlXU","id":"Transactions_id__U9bQd","commodity":"Transactions_commodity__183qc"};